import React, { useEffect } from 'react';
import Navigation from '../components/Navigation';
import AwningsHeroSection from '../components/awnings/AwningsHeroSection';
import AwningsProductTiers from '../components/awnings/AwningsProductTiers';
import AwningsFeatures from '../components/awnings/AwningsFeatures';
import AwningsProjects from '../components/awnings/AwningsProjects';
import AwningsFAQ from '../components/awnings/AwningsFAQ';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import AwningsPromotionBanner from '../components/awnings/AwningsPromotionBanner';

const AwningsPage: React.FC = () => {
  useEffect(() => {
    // Google Analytics
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = 'https://www.googletagmanager.com/gtag/js?id=G-SDHCNDS5MG';
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-SDHCNDS5MG');
    `;
    document.head.appendChild(script2);

    // Set document title and meta tags
    document.title = 'Premium Motorized Awnings | Evie Outdoors Ontario';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Cool your patio by up to 12°C with premium motorized awnings. German Somfy motors, smart home integration. Starting at $3,295 installed. Save $200-400 per summer on AC costs.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'awnings Ontario, motorized awnings, retractable awnings, Somfy motors, smart home awnings, energy savings, patio cooling, German motors, vertical drop awnings');
    }

    // Add structured data for SEO
    const structuredData = document.createElement('script');
    structuredData.type = 'application/ld+json';
    structuredData.innerHTML = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "Premium Motorized Awnings",
      "description": "Cool your patio by up to 12°C with premium motorized awnings featuring German Somfy motors and smart home integration",
      "image": [
        "https://evieoutdoors.com/images/awnings/garden-folding-arm-awnings629a0.webp",
        "https://evieoutdoors.com/images/awnings/retractable-outdoor-awnings6e8d6 (1).webp",
        "https://evieoutdoors.com/images/awnings/vertical drop awning.webp"
      ],
      "brand": {
        "@type": "Brand",
        "name": "Evie Outdoors"
      },
      "offers": {
        "@type": "Offer",
        "price": "3295",
        "priceCurrency": "CAD",
        "availability": "https://schema.org/InStock",
        "priceValidUntil": "2025-12-31",
        "shippingDetails": {
          "@type": "OfferShippingDetails",
          "shippingRate": {
            "@type": "MonetaryAmount",
            "value": "0",
            "currency": "CAD"
          },
          "deliveryTime": {
            "@type": "ShippingDeliveryTime",
            "handlingTime": {
              "@type": "QuantitativeValue",
              "minValue": 7,
              "maxValue": 14,
              "unitCode": "DAY"
            },
            "transitTime": {
              "@type": "QuantitativeValue",
              "minValue": 1,
              "maxValue": 1,
              "unitCode": "DAY"
            }
          },
          "shippingDestination": {
            "@type": "DefinedRegion",
            "addressCountry": "CA",
            "addressRegion": "ON"
          }
        },
        "hasMerchantReturnPolicy": {
          "@type": "MerchantReturnPolicy",
          "applicableCountry": "CA",
          "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow",
          "merchantReturnDays": 30,
          "returnMethod": "https://schema.org/ReturnByMail",
          "returnFees": "https://schema.org/FreeReturn"
        }
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "reviewCount": "47"
      }
    });
    document.head.appendChild(structuredData);

    // Cleanup function
    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
      document.head.removeChild(structuredData);
    };
  }, []);

  return (
    <div className="bg-white">
      <AwningsPromotionBanner />
      <Navigation />
      <AwningsHeroSection />
      <AwningsProductTiers />
      <AwningsFeatures />
      <AwningsProjects />
      <AwningsFAQ />
      <CTASection />
      <Footer />
    </div>
  );
};

export default AwningsPage;
